import React from 'react'
import { close_icon } from '../../assets/images';
import { dsButtonPrimary, dsButtonSecondary, joinButtonClasses } from '../../utils/buttonStyles';


const TestMailModal = ({ visible = true, icon , title , description, onClose = () => {}, onSave = () => {}, inputVal = () => {} }) => {
  
  const emailChangeHandler = (email) => {
    inputVal(email.target.value);
 }

  return ( 
    <div
      className={`fixed z-20 inset-0 overflow-y-auto ${visible ? '' : 'hidden'}`}
      aria-labelledby='modal-title'  
      aria-modal='true'
      style={{width: '100%'}}
    >
      <div className='flex items-end justify-center text-center sm:block sm:p-0'>
        <div
          className='fixed inset-0 transition-opacity'
          aria-hidden='true'
          style={{background: 'grey', opacity: '0.9', transition: 'opacity' }}
        >
        </div>
        <span className='sm:inline-block sm:align-middle sm:h-screen' aria-hidden='true'>
          &#8203;
        </span>  
        <div className="inline-block  align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-75 sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className='flex flex-row-reverse '>
              <img src={close_icon} alt='closeIcon' className='cursor-pointer' onClick={onClose} />
            </div>   
            <div className=" sm:flex sm:items-start">
              <div className="text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3 className='text-xl leading-6 font-extrabold text-gray-700 ' id='modal-title'>
                    {title}
                </h3>    
                <div className='text-sm mt-8 leading-5 font-semibold text-gray-400 uppercase'>
                  {description}</div> 
                <input
                  onChange={emailChangeHandler}
                  placeholder='Ex.  wellness@ekincare.com, hr@ekincare.com' 
                  className='font-semibold text-base focus:outline-none px-4 border-2 rounded-md mt-2' 
                  style={{ width: 690, height: 48, color:'#1C2251', background: '#F9FAFB'}}
                /> 
                <p className='text-sm font-norma pt-3 pl-0.5'>Use commas to separate multiple emails</p> 
              </div>
            </div>
          </div>
          <div className="bg-gray-100 h-20 py-3 pb-5 sm:px-8 sm:flex sm:flex-row-reverse" style={{borderWidth: '1px'}}>
            <button onClick = {onSave} className={joinButtonClasses(dsButtonPrimary, 'h-10 px-6')}>Send Test</button>
            <button onClick ={onClose} className={joinButtonClasses(dsButtonSecondary, 'mx-4 h-11 px-6')}>No, cancel</button>
          </div>
        </div>
      </div>
    </div>   
  )
}

export default TestMailModal;
